import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "primary-filter__title" };
const _hoisted_2 = {
    key: 0,
    class: "primary-filter__dropdown"
};
const _hoisted_3 = ["onClick"];
import { onMounted, ref } from 'vue';
import { useClickaway } from "../composables/clickaway";
import Icon from "./Icon.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SearchFiltersPrimaryFilter',
    props: {
        filter: {},
        state: {}
    },
    emits: [
        'select',
        'clear'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const root = ref(null);
        const showDropdown = ref(false);
        onMounted(() => useClickaway(root, hideDropdown));
        function select(option) {
            emit('select', option);
            hideDropdown();
        }
        function clear() {
            emit('clear');
            hideDropdown();
        }
        function filterTitle() {
            if (!props.state) {
                return props.filter.label;
            }
            const choices = props.filter.choices;
            const choice = Array.isArray(choices) ? choices.find(c => c.value === props.state?.value) : undefined;
            return choice && choice.label;
        }
        function toggleDropdown() {
            showDropdown.value = !showDropdown.value;
        }
        function hideDropdown() {
            showDropdown.value = false;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["primary-filter", { 'primary-filter--open': showDropdown.value }]),
                ref_key: "root",
                ref: root
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("h2", null, _toDisplayString(filterTitle()), 1),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    (Array.isArray(__props.filter.choices) && __props.filter.choices.length > 0)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _cache[0] || (_cache[0] = ($event) => (toggleDropdown())),
                            href: ""
                        }, [
                            _createVNode(Icon, {
                                name: showDropdown.value ? 'angle-up' : 'angle-down'
                            }, null, 8, ["name"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[4] || (_cache[4] = _createTextVNode()),
                (Array.isArray(__props.filter.choices) && __props.filter.choices.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        (__props.state)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (clear()), ["prevent"])),
                                class: "primary-filter__dropdown-item primary-filter__dropdown-item--all"
                            }, _toDisplayString(__props.filter.label), 1))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filter.choices, (choice) => {
                            return (_openBlock(), _createElementBlock("div", {
                                onClick: _withModifiers(($event) => (select(choice)), ["prevent"]),
                                key: choice.value,
                                class: "primary-filter__dropdown-item"
                            }, _toDisplayString(choice.label), 9, _hoisted_3));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true)
            ], 2));
        };
    }
});
